
import { Form, FormItem, Input } from 'element-ui';
import { cloneDeep } from 'lodash';
export default {
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElInput: Input,
    VDistpicker: () => {
      return import('v-distpicker');
    },
  },
  props: {
    form: {
      type: Object,
      default() {
        return {
          name: '',
          phone: '',
          area: '',
          address: '',
          temp: {
            state: '',
            city: '',
            dist: '',
          },
        };
      },
    },
  },
  data() {
    return {
      formatForm: {
        name: '',
        phone: '',
        area: '',
        address: '',
        temp: {
          state: '',
          city: '',
          dist: '',
        },
      },
      rules: {
        name: [
          {
            required: true,
            max: 20,
            message: '请填写正确的姓名格式（不能为空且小于20字符）',
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            trigger: 'blur',
            validator(rule, val, callback) {
              if (!val || (val.length !== 11 && val.length !== 8)) {
                callback('请填写正确的手机号码（大陆11位，香港澳门8位）');
              }
              callback();
            },
          },
        ],
        temp: [
          {
            required: true,
            trigger: 'blur',
            validator: (rule, val, callback) => {
              for (const prop in this.formatForm.temp) {
                if (!this.formatForm.temp[prop]) {
                  callback('请选择所在地区');
                }
              }
              callback();
            },
          },
        ],
        address: [
          { required: true, message: '请填写准确的详细地址', trigger: 'blur' },
        ],
      },
    };
  },
  beforeMount() {
    for (const prop in this.form) {
      this.formatForm[prop] = cloneDeep(this.form[prop]);
    }
  },

  methods: {
    onSelected(data) {
      this.formatForm.area = `${data.province.value}${data.city.value}${data.area.value}`;
      this.formatForm.temp.state = data.province.value;
      this.formatForm.temp.city = data.city.value;
      this.formatForm.temp.dist = data.area.value;
    },
    handleBtn(val) {
      if (val === 'submit') {
        this.$refs.form.validate(res => {
          if (res) {
            this.$emit('handleBtn', {
              type: val,
              form: this.formatForm,
            });
          }
        });
      } else {
        this.$emit('handleBtn', {
          type: val,
        });
      }
    },
  },
};
